<helsana-lerb-finder
  [mode]="getMode()"
  [language]="getLanguage()"
  [host]="getHost()"
  [initialType]="getInitialType()"
  (lerbFinderClose)="lerbFinderClose()"
  (doctorSelect)="doctorSelect($event)"
  [product]="getProduct()"
  [offsetTop]="getOffSetTop()"
  (scrollOffset)="setScrollOffset($event)"
  (scrollEvent)="handleScrollEvent($event)"
  [isOverlayMode]="getIsOverlayMode()"
></helsana-lerb-finder>
